import { Editor } from 'slate';
import { findLink } from './findLink.mjs';

function hasText(editor) {
  const linkEntry = findLink(editor);
  if (!linkEntry) {
    return false;
  }
  const [, path] = linkEntry;
  return Editor.string(editor, path) !== '';
}

export { hasText };
